/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
import { Highlight, StandoutLink } from 'design-system';
import * as React from 'react';
import { translate } from '../../../helpers/l10n';

export default function NoFavoriteProjects() {
  return (
    <div className="sw-py-8 sw-text-center">
      <Highlight as="h3" className="sw-mb-2 sw-body-md-highlight">
        {translate('projects.no_favorite_projects')}
      </Highlight>

      <div>
        <p className="sw-mt-2 sw-body-sm">
          {translate('projects.no_favorite_projects.engagement')}
        </p>
        <p className="sw-mt-6">
          <StandoutLink className="sw-mt-6 sw-body-sm-highlight" to="/projects/all">
            {translate('projects.explore_projects')}
          </StandoutLink>
        </p>
      </div>
    </div>
  );
}
